<script>
import Markdown from "vue3-markdown-it";
import { uuid } from "vue-uuid";
import { supabase } from "../supabase";

export default {
  props: {
    id: {
      type: String,
      required: false,
    },
  },
  components: {
    Markdown,
  },
  data() {
    return {
      card: null,
      //   TODO: check what of the following one's is actually needed
      searchTerm: "",
      buttonsEnabled: true,
      front: "...loading",
      back: "...loading",
      queueLoading: true,
      currentCard: null,
      followingCard: null,
      overlay: false,
      savedVote: null,
      savedScore: null,
      skipNote: "",
      showCelebration: true,
      stickerIsMoving: false,
      activeSticker: null,
      stopStickerListenerActive: false,
    };
  },
  created() {
    this.getCard().then(() => {
      this.replaceImages();
    });
  },
  methods: {
    async replaceImages() {
      if (this.card !== null && this.card !== undefined) {
        this.front = this.card.front || "";
        this.back = this.card.back || "";
        const regex = /{{ ([^}]*) }}/gm;
        let matches = this.card.front.match(regex);
        if (matches !== null) {
          for (const match of matches) {
            const imgName = match.replace("{{ ", "").replace(" }}", "");
            try {
              const { data, error } = supabase.storage
                .from("user-images")
                .getPublicUrl(`${supabase.auth.currentUser.id}/${imgName}`);
              if (error) throw error;

              this.front = this.front.replace(
                match,
                `![${imgName}](${data.publicURL})`
              );
            } catch (error) {
              console.warn(error);
            }
          }
        }
        matches = this.card.back.match(regex);
        if (matches !== null) {
          for (const match of matches) {
            const imgName = match.replace("{{ ", "").replace(" }}", "");
            try {
              const { data, error } = supabase.storage
                .from("user-images")
                .getPublicUrl(`${supabase.auth.currentUser.id}/${imgName}`);
              if (error) throw error;

              this.back = this.back.replace(
                match,
                `![${imgName}](${data.publicURL})`
              );
            } catch (error) {
              console.warn(error);
            }
          }
        }
      }
    },
    getCard: async function () {
      // if id was passed in, get the card from the database
      // otherwise, create a new card
      if (this.id) {
        const { data, error } = await supabase
          .from("cards")
          .select("*")
          .eq("id", this.id);
        if (error) {
          console.log("error", error);
        } else {
          this.card = data[0];
        }
      } else {
        this.card = {
          id: uuid.v4(),
          //   TODO: some stuff here should be cloned I think?
          type: "standard",
          front: "",
          back: "",
          nextShown: new Date() / 1000,
          ease: 0,
          interval: 1,
          repetition: 0,
          unit: "days",
          pack_id: null,
          // TODO: think about where to get pack_id or if we kill packs first
          occurrences: 0,
        };
      }
    },
  },
};
</script>

<template>
  <div
    class="card queue-card"
    id="inner-queue-card"
    :class="card.type"
    v-if="card"
  >
    <div class="top-row" id="top-row">
      {{ card.pack_name }}
    </div>

    <div
      v-for="sticker in card.stickers"
      :key="sticker.id"
      class="sticker"
      :style="{
        top: sticker.y + 'px',
        left: sticker.x + 'px',
      }"
    >
      {{ sticker.sticker }}
    </div>

    <div id="front">
      <Markdown
        v-if="card.type === 'project'"
        :source="'## Work on this project: \n' + front"
        :class="{
          'normal-text': card.front.length > 100,
          'align-left': card.front.length > 100,
        }"
      />

      <Markdown
        v-else-if="card.type === 'readingList'"
        :source="'## Read at least a page of: \n' + front"
        :class="{
          'normal-text': card.front.length > 100,
          'align-left': card.front.length > 100,
        }"
      />

      <Markdown
        v-else-if="card.type === 'articleList'"
        :source="'## Read this and make notes: \n' + front"
        :class="{
          'normal-text': card.front.length > 100,
          'align-left': card.front.length > 100,
        }"
      />
      <Markdown
        v-else
        :source="front"
        :class="{
          'normal-text': card.front.length > 100,
          'align-left': card.front.length > 100,
        }"
      />
    </div>
    <div
      id="queue-spacer"
      v-if="showBack || (card.occurrences == 0 && card.type == 'learn')"
    ></div>
    <Markdown
      v-if="showBack || (card.occurrences == 0 && card.type == 'learn')"
      :source="back"
      :class="{
        'normal-text': card.back.length > 100,
        'align-left': card.back.length > 100,
      }"
      id="back"
    />
  </div>
</template>